'use client';

import { useEffect, useRef } from 'react';

import styles from './application.module.scss';

export const BgApplication = () => {
  const backgroundRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.active);
            entry.target.classList.remove(styles.inactive);
          } else {
            entry.target.classList.remove(styles.active);
            entry.target.classList.add(styles.inactive);
          }
        });
      },
      {
        root: null,
        rootMargin: '0% 0px -50% 0px',
        threshold: 0,
      }
    );

    const currentRef = backgroundRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div ref={backgroundRef} className={styles['bg-application']}>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
      <div className={styles.application}>
        <Application />
      </div>
    </div>
  );
};

interface ApplicationProps {
  width?: string;
  height?: string;
}
const Application = ({ width = '100%', height = '100%' }: ApplicationProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1432 404"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Company logo"
    >
      <path
        d="M426.394 239.269L452.659 157.277H476.085L502.222 239.269L500.358 242.231H487.649L481.846 223.531H446.728L440.797 242.231H428.343L426.352 239.269H426.394ZM450.922 209.865H477.779L465.452 170.985H463.122L450.922 209.865Z"
        fill="#610AFD"
      />
      <path
        d="M516.964 242.231V157.319H557.885C571.271 157.319 577.964 164.004 577.964 177.373V193.746C577.964 207.031 571.271 213.673 557.885 213.673H532.002V242.231H516.964ZM532.002 200.008H557.504C561.104 200.008 562.926 198.188 562.926 194.592V176.273C562.926 172.761 561.104 170.985 557.504 170.985H532.002V200.05V200.008Z"
        fill="#610AFD"
      />
      <path
        d="M594.994 242.231V157.319H635.915C649.302 157.319 655.995 164.004 655.995 177.373V193.746C655.995 207.031 649.302 213.673 635.915 213.673H610.032V242.231H594.994ZM610.032 200.008H635.534C639.135 200.008 640.956 198.188 640.956 194.592V176.273C640.956 172.761 639.135 170.985 635.534 170.985H610.032V200.05V200.008Z"
        fill="#610AFD"
      />
      <path d="M672.982 242.231V157.319H688.02V228.565H726.484V242.231H672.982Z" fill="#610AFD" />
      <path d="M741.607 242.231V157.319H756.646V242.231H741.607Z" fill="#610AFD" />
      <path
        d="M775.116 222.134V177.331C775.116 163.961 781.809 157.277 795.195 157.277H828.703L835.989 162.946V170.942H795.576C791.976 170.942 790.154 172.719 790.154 176.231V223.234C790.154 226.746 791.976 228.523 795.576 228.523H835.989V236.519L828.703 242.188H795.195C781.809 242.188 775.116 235.504 775.116 222.134Z"
        fill="#610AFD"
      />
      <path
        d="M848.613 239.269L874.877 157.277H898.303L924.441 239.269L922.577 242.231H909.868L904.065 223.531H868.947L863.016 242.231H850.562L848.571 239.269H848.613ZM873.141 209.865H899.998L887.671 170.985H885.341L873.141 209.865Z"
        fill="#610AFD"
      />
      <path
        d="M924.737 170.942V157.277H993.363V170.942H966.633V242.188H951.467V170.942H924.737Z"
        fill="#610AFD"
      />
      <path d="M1008.49 242.231V157.319H1023.52V242.231H1008.49Z" fill="#610AFD" />
      <path
        d="M1041.99 222.134V177.331C1041.99 163.961 1048.69 157.277 1062.07 157.277H1090.29C1103.67 157.277 1110.37 163.961 1110.37 177.331V222.134C1110.37 235.504 1103.67 242.188 1090.29 242.188H1062.07C1048.69 242.188 1041.99 235.504 1041.99 222.134ZM1057.03 223.277C1057.03 226.788 1058.85 228.565 1062.45 228.565H1089.95C1093.55 228.565 1095.37 226.788 1095.37 223.277V176.273C1095.37 172.761 1093.55 170.985 1089.95 170.985H1062.45C1058.85 170.985 1057.03 172.761 1057.03 176.273V223.277Z"
        fill="#610AFD"
      />
      <path
        d="M1128.75 242.231V157.319H1145.14L1182.85 217.861V157.319H1197.88V242.231H1181.62L1143.79 181.688V242.231H1128.75Z"
        fill="#610AFD"
      />
      <path
        d="M1229.49 2.00781H202.513C91.781 2.00781 2.01514 91.6498 2.01514 202.229C2.01514 312.808 91.781 402.45 202.513 402.45H1229.49C1340.22 402.45 1429.98 312.808 1429.98 202.229C1429.98 91.6498 1340.22 2.00781 1229.49 2.00781Z"
        stroke="#610AFD"
        strokeWidth="2.83"
        strokeMiterlimit="10"
      />
      <path
        d="M297.572 142.173L294.565 143.146L278.425 144.585L273.808 151.861L270.503 150.804L257.414 139.169L255.507 133.119L252.923 126.646L244.79 119.369L235.174 117.508L234.962 121.865L244.366 131.046L248.984 136.419L243.815 139.169L239.622 137.942L233.31 135.277V130.2L225.303 126.773L222.55 138.746L214.205 140.608L215.052 147.292L225.981 149.365L227.887 138.704L236.868 140.058L241.02 142.512H247.713L252.203 151.565L264.403 163.877L263.471 168.7L253.643 167.473L236.699 176.019L224.499 190.615L222.931 197.088H218.526L210.392 193.45L202.47 197.088L204.461 205.423L207.893 201.446H213.993L213.569 208.723L218.61 210.161L223.736 215.958L231.742 213.504L241.104 214.942L252.034 217.861L257.414 218.538L266.606 228.946L284.356 239.354L272.876 261.227L260.76 266.854L256.143 279.377L238.605 291.054L236.741 297.781C291.557 284.411 325.107 229.2 311.721 174.454C308.883 162.946 304.096 151.988 297.53 142.131L297.572 142.173Z"
        fill="#610AFD"
      />
      <path
        d="M224.499 252.258L217.212 238.465L223.906 224.419L217.085 222.388L209.418 214.688L192.431 211.05L186.797 198.908V205.888H184.297L169.683 186.046V169.715L158.965 152.285L141.936 155.288H130.413L124.61 151.65L131.896 145.812L124.61 147.504C96.2275 196.2 112.706 258.646 161.464 287.034C177.054 296.088 194.718 300.869 212.722 300.911C217.001 300.869 221.279 300.573 225.515 299.981L224.456 287.627C224.456 287.627 229.158 269.392 229.158 268.673C229.158 267.954 224.456 252.173 224.456 252.173L224.499 252.258Z"
        fill="#610AFD"
      />
      <path
        d="M148.587 129.692L166.844 127.154L175.19 122.585L184.594 125.292L199.632 124.446L204.8 116.365L212.299 117.592L230.556 115.9L235.597 110.358L242.884 105.662L252.881 107.142L256.524 106.592C214.332 86.6231 163.921 97.877 134.268 133.881L148.587 129.692ZM217.043 107.015L227.337 101.304L234.03 105.154L224.329 112.431L215.052 113.362L210.901 110.654L217.043 106.973V107.015ZM186.161 107.819L190.863 109.808L196.794 107.819L200.098 113.488L186.161 117.127L179.468 113.277C179.468 113.277 185.992 109.088 186.161 107.819Z"
        fill="#610AFD"
      />
    </svg>
  );
};
